module.exports = __webpack_public_path__ + "img/pic_zs_4@2x.f5c89575.png";